import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { fetchServicePartnerById } from "@/lib/api/resources/servicePartners";
import { ServicepartnerChangeRequestForm } from "./components/ServicepartnerChangeRequestForm";

export const ServicepartnerChangeRequest = () => {
  const { id } = useParams();
  if (!id) return null;

  const { data, isLoading } = useQuery({
    queryKey: ["service-partner", id],
    queryFn: () => fetchServicePartnerById(id),
  });

  return (
    <ServicepartnerChangeRequestForm
      servicePartner={data}
      loading={isLoading}
    />
  );
};
